<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetContentSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    content: '',
    backgroundImage: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Treść]]]')" :invalid-feedback="form.$errors.first('settings.content')" :state="form.$errors.state('settings.content')">
        <RichTextEditor id="editorContent" v-model="form.settings.content" />
    </IdeoFormGroup>

    <IdeoFormGroup :label="$t('[[[Zdjęcie w tle]]]')" :invalid-feedback="form.$errors.first(`settings.backgroundImage`)" :state="form.$errors.state(`settings.backgroundImage`)">
        <IdeoFilePicker id="backgroundImage" v-model="form.settings.backgroundImage" media="images" />
    </IdeoFormGroup>
</template>
